export default __webpack_public_path__ + "static/media/boldare_products.aea8acdc.mp4";